var bind = function (fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};
var $ = jQuery;

/* --------------------------------------------
  Initialization
  @Params: jQuery element
  @Returns: none
*/
var Autocomplete = function ($element) {
  this.complete = bind(this.complete, this);
  this.value = null;
  this.data = null;

  var object = $element.attr("data-object"),
    length = $element.attr("data-length");
  count = 0;

  $element.autocomplete({
    minLength: length,
    source: function (request, response) {
      $.ajax({
        url: "ajax/" + object + ".php",
        data: {
          value: request.term,
        },
        success: function (data) {
          var array = JSON.parse(data);
          response(array);
        },
      });
    },
    focus: function (event, data) {
      event.preventDefault();
    },
    search: function (event, data) {
      // console.log('search');
      count = 0;
      $element.addClass("input--loading");
      Autocomplete.prototype.value = null;
      Autocomplete.prototype.disableForm($element);
    },
    response: function (event, data) {
      //console.log('response');
      $element.removeClass("input--loading");

      Autocomplete.prototype.data = data;
      Autocomplete.prototype.enableForm($element);
    },
    open: function (event, data) {},
    create: function () {
      $(this).data("ui-autocomplete")._renderItem = function (ul, item) {
        var completeName =
          item.nom && item.prenom
            ? item.nom + " " + item.prenom
            : item.compagnie;
        var title = object == "codepostal" ? "code postal" : "numéro";
        var notice =
          object == "codepostal"
            ? "(appuyer ESC pour compléter les champs Ville, Province et Pays) "
            : "";

        count = count + 1;

        if (count == 1) {
          $("<li/>", {
            class: "autocomplete__results",
            html:
              '<span class="results__label">Résultats correspondant à ce ' +
              title +
              " " +
              notice +
              ':</span><span class="results__close"><img src="/assets/images/icon-close@2x.png" width="13" /></span>',
          }).appendTo(ul);
        }

        var autocompleteItem = $("<li/>", {
          class: "autocomplete__item",
          html:
            '<div class="item__wrapper"><span class="item__name">' +
            completeName +
            '</span><span class="item__address">' +
            item.adresseComplete +
            "</span></div>",
        }).appendTo(ul);

        $(".new_item").remove();
        $(".results__close").remove();
        $("<li/>", {
          class: "autocomplete__item",
          html: '<div class="item__wrapper results__close"><span class="item__name">Créer un nouveau profil</div>',
        }).appendTo(ul);

        return autocompleteItem;
      };
    },
    select: function (event, data) {
      event.preventDefault();
      Autocomplete.prototype.value = data;
    },
    close: function (event, data) {
      if (
        object == "codepostal" &&
        Autocomplete.prototype.value == null &&
        Autocomplete.prototype.data
      ) {
        Autocomplete.prototype.completeCodepostal(
          Autocomplete.prototype.data.content[0],
        );
      } else {
        if (Autocomplete.prototype.value && Autocomplete.prototype.value.item) {
          Autocomplete.prototype.complete(Autocomplete.prototype.value);

          if (object == "telephone") {
            $element.val(
              Autocomplete.prototype.value.item[object].replace(
                /(\d{3})(\d{3})(\d{4})/,
                "$1 $2-$3",
              ),
            );
          } else {
            $element.val(Autocomplete.prototype.value.item[object]);
          }

          $(".js-input-autocomplete").autocomplete("disable");
          $(".js-mask-field").trigger("input");
          $(".js-input-autocomplete").autocomplete("enable");
        } else {
          // $('.form')[0].reset();
        }
      }
    },
  });

  var $form = $(".form");
  var $wrapper = $("<div/>", { class: "autocomplete" });
  var $menu = $element.autocomplete("widget");
  $menu.addClass("autocomplete__menu");
  $menu.detach();

  $form.append($wrapper);
  $wrapper.append($menu);
};

/* --------------------------------------------
  Disable form
  @Params: data
  @Returns: none
*/
Autocomplete.prototype.enableForm = function ($element) {
  if ($(".js-nuq").val() != "") {
    $element
      .parents("form")
      .find("input, select")
      .not(".js-field-locked-on-autocomplete")
      .prop("disabled", false);
  } else {
    $element.parents("form").find("input, select").prop("disabled", false);
  }

  // .not('.js-field-locked-on-autocomplete')
  $(".js-dimmable").removeClass("dimmable--dimmabled");
  $element.autocomplete("enable");
  $element.trigger("focus");
  $(document).off("keydown", Autocomplete.prototype.disableKeyboard);
};

/* --------------------------------------------
  Disable form
  @Params: data
  @Returns: none
*/
Autocomplete.prototype.disableForm = function ($element) {
  $element.parents("form").find("input, select").prop("disabled", true);
  $element.autocomplete("disable");
  $(".js-dimmable").addClass("dimmable--dimmabled");
  $(document).on("keydown", Autocomplete.prototype.disableKeyboard);
};

/* --------------------------------------------
  Complete
  @Params: data
  @Returns: none
*/
Autocomplete.prototype.completeCodepostal = function (data) {
  // console.log('complete for codepostal');
  if ($("[name='codepostal']").val() == "") {
    $("[name='codepostal']").val(data.codepostal);
  }
  if ($("[name='pays']").val() == "") {
    $("[name='pays']").val(data.pays);
  }
  if ($("[name='province']").val() == "") {
    $("[name='province']").val(data.province);
  }
  if ($("[name='ville']").val() == "") {
    $("[name='ville']").val(data.ville);
  }
};

/* --------------------------------------------
  Complete
  @Params: data
  @Returns: none
*/
Autocomplete.prototype.disableKeyboard = function (e) {
  return false;
};

/* --------------------------------------------
  Complete
  @Params: data
  @Returns: none
*/
Autocomplete.prototype.complete = function (data) {
  $.each(data.item, function (i, n) {
    if (i == "telephone") {
      if ($("[name='telephone']").val() == "") {
        $("[name='" + i + "']").val(
          n.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2-$3"),
        );
      }
    }
    if (i == "prenom" || i == "nom") {
      if (n != "") {
        $("[name='" + i + "']")
          .val(n)
          .trigger("change");
        $("[name='" + i + "']").attr("disabled", "disabled");
      } else {
        $("[name='" + i + "']")
          .val("")
          .trigger("change");
        $("[name='" + i + "']").removeAttr("disabled");
      }
    } else {
      $("[name='" + i + "']")
        .val(n)
        .trigger("change");
    }
  });

  // Trigger validation on input
  $(".js-field").trigger("autocomplete:close");
};

module.exports = Autocomplete;
